import net from '../../utils/net'
export default {
  // 获取设备列表
  GetEquipmentList (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  },
  EditArm (methods, url, params, baseUrl) {
    return new Promise((resolve, reject) => {
      net.get(methods, url, params, baseUrl)
        .then(data => resolve(data))
        .catch(err => reject(err))
    })
  }
}
